import React from 'react';
import {
  AppstoreOutlined,
  ShoppingOutlined,
  TeamOutlined,
  LogoutOutlined,
  UnorderedListOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { type JsonDataItem, type JsonData } from 'types';

// this structure will be rendered in the menu
// update the "urlHierarchy" object to get the proper highlighting
export const menuConfig: JsonData = [
  {
    label: 'Dashboard',
    key: '/dashboard',
    icon: <AppstoreOutlined />,
  },
  {
    label: 'GeekTasks',
    key: 'tasks-group',
    icon: <UnorderedListOutlined />,
    children: [
      {
        label: 'Tickets',
        key: '/tasks/tickets',
      },
      {
        label: 'Callbacks',
        key: '/tasks/callbacks',
      },
    ],
  },
  {
    label: 'Jobs',
    key: 'job-group',
    icon: <ShoppingOutlined />,
    children: [
      {
        label: 'Book a job',
        key: '/booking/start',
      },
      {
        label: 'Find a job',
        key: '/job/search',
      },
    ],
  },
  {
    label: 'Customers',
    key: 'customer-group',
    icon: <TeamOutlined />,
    children: [
      {
        label: 'Create a customer',
        key: '/customer/create',
      },
      {
        label: 'Find a customer',
        key: '/customer/search',
      },
    ],
  },
  {
    label: 'Technicians',
    key: 'technician-group',
    icon: <UserOutlined />,
    children: [
      // {
      //   label: 'Create a technician',
      //   key: '/technician/create',
      //   disabled: true,
      // },
      {
        label: 'Find a technician',
        key: '/technician/search',
      },
    ],
  },
  {
    label: 'Logout',
    key: '/logout',
    icon: <LogoutOutlined />,
  },
];

// this structure indicates the selection in the rendered menu
// key names corresponds to the "key" value of each menu item from "menuConfig"
// values are set of url's that activate the menu item with an appropriate "key"
const urlHierarchy: JsonData = [
  { keys: [{ '/dashboard': ['/dashboard'] }] },
  {
    group: 'tasks-group',
    keys: [{ '/tasks/callbacks': ['/tasks/callbacks'] }, { '/tasks/tickets': ['/tasks/tickets'] }],
  },
  {
    group: 'customer-group',
    keys: [
      { '/customer/create': ['/customer/create'] },
      { '/customer/search': ['/customer/search', '/customer/edit'] },
    ],
  },
  {
    group: 'job-group',
    keys: [
      { '/job/search': ['/job/search', '/job/reschedule', '/job/cancel', '/job/edit'] },
      {
        '/booking/start': [
          '/booking/start',
          '/booking/location',
          '/booking/technician',
          '/booking/payment',
          '/booking/confirmation',
        ],
      },
    ],
  },
  {
    group: 'technician-group',
    keys: [
      { '/technician/create': ['/technician/create'] },
      { '/technician/search': ['/technician/search', '/technician/edit'] },
    ],
  },
];

// define selected link and opened group based on the url and hierarchy data
export const getMenuState = (url: string, isSidebarCollapsed: boolean) => {
  let selectedKeys;
  let openKeys;

  const menuItem = urlHierarchy.find((menuItem) =>
    menuItem.keys?.some((key: JsonDataItem) => {
      return Object.values(key)[0].some((item: string) => url.includes(item));
    }),
  );

  if (menuItem) {
    const hierarchyObject = menuItem.keys.find((obj: JsonDataItem) => {
      return Object.values(obj)[0].some((item: string) => url.includes(item));
    });

    selectedKeys = Object.keys(hierarchyObject);
    openKeys = !isSidebarCollapsed && menuItem.group ? [menuItem.group] : undefined;
  }

  return { selectedKeys, openKeys };
};
